export const transformCentsInDefaultPattern = (priceInCents: number | string) => {
	const castedNumber = +priceInCents
	if (!Number.isInteger(castedNumber)) {
		return null
	}

	return (castedNumber / 100).toFixed(2).replace(".", ",")
}
